import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import FormMensaisPort from "../../MetasPortfolio/FormMensaisPort";

export default class Form extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta",
            metas: null
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevProps.metas !== this.props.metas) {
            this.setState({ metas: this.props.metas });
        }
    }

    async componentDidMount() {
        this.setState({ metas: this.props.metas });
    }

    render() {
        let metas = this.state.metas
        let isDisabled = metas && metas.linhaAtuacao === "Metrologia" ? true : false;
        return (
            <Fragment>
                <div className="row pr-3 pl-3">
                        <div className="col-md-12 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h5 className="card-title">Editar Metas por Portfólio</h5>
                                    <button className="btn btn-btn-danger btn-round" onClick={() => window.history.back()}>Voltar</button>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.props.onSubmit} className="gap" onChange={this.props.onChange}>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="linhaAtuacao">Linha de Atuação:</label>
                                                    <select name="linhaAtuacao" id="linhaAtuacao" onChange={this.props.onChangeLinha} className="form-control" disabled required>
                                                        <option>{metas && metas.linhaAtuacao}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <label htmlFor="categoria">Categorias:</label>
                                                    <select name="categoria" id="categoria" onChange={this.props.onChangeCategoria} className="form-control" disabled required>
                                                        <option>{metas && metas.categoria}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="cr">CR</label>
                                                    <input type="text" className="form-control" placeholder="cr" id="cr" name="cr" defaultValue={metas && metas.cr} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="produtoNacional">Produto:</label>
                                                    <select name="produtoNacional" onChange={this.props.onChangeProduto} className="form-control" disabled required>
                                                        <option>{metas && metas.Produto}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                {/*produtoSelecionado 
                                                    && 
                                                    <span>
                                                        <span className="btn btn-link btn-danger remove" onClick={() => this.props.exibeFichaSweetAlert("produtoSelecionado")}>
                                                            <i className="fa fa-times"></i>Detalhes
                                                        </span>
                                                    </span>
                                                */}
                                            </div>
                                        </div>

                                        <div className="row">

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="metaEmpresasAtendidas">Meta de Empresas Atendidas</label>
                                                    <input type="value" className="form-control" placeholder="0" id="metaEmpresasAtendidas" name="metaEmpresasAtendidas" defaultValue={metas && metas.metaEmpresasAtendidas} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="metaAtendimentos">Meta de Atendimento</label>
                                                    <input type="value" className="form-control" placeholder="0" id="metaAtendimentos" name="metaAtendimentos" defaultValue={metas && metas.metaAtendimentos} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="mediaHH">Média de H.H por atendimento</label>
                                                    {/* <input type="number" step="1" className="form-control" placeholder="0" id="mediaHH" name="mediaHH" defaultValue={metas && metas.mediaHH} disabled={isDisabled} /> */}
                                                    <input type="value" className="form-control" placeholder="0" id="mediaHH" name="mediaHH" defaultValue={metas && metas.mediaHH}/>
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalHH">H.H Total</label>
                                                    <input type="value" className="form-control" placeholder="0" id="totalHH" name="totalHH" disabled defaultValue={metas && metas.totalHH} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalEnsaiosCalibracoes">Total Ensaios / Calibrações</label>
                                                    <input type="value" className="form-control" placeholder="0,00" id="totalEnsaiosCalibracoes" name="totalEnsaiosCalibracoes" defaultValue={metas && metas.totalEnsaiosCalibracoes} disabled={!isDisabled} />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="totalLaudosRelatorios">Total Laudos / Relatórios</label>
                                                    <input type="value" className="form-control" placeholder="0,00" id="totalLaudosRelatorios" name="totalLaudosRelatorios" defaultValue={metas && metas.totalLaudosRelatorios} disabled={!isDisabled} />
                                                </div>
                                            </div>

                                            <input type="hidden" step="0.01" className="form-control" placeholder="0,00" id="valorHora" name="valorHora" defaultValue={metas && metas.valorHora} />
                                            <input type="hidden" className="form-control" placeholder="0,00" id="receitaPrevista" name="receitaPrevista" disabled defaultValue={metas && metas.receitaPrevista} />

                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Informações adicionais</label>
                                                    <textarea className="form-control textarea" name="comentario" placeholder={"Escreva algo..."} defaultValue={metas && metas.comentario}></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <FormMensaisPort unidade={"unidade"} {...this.state} linhaSelecionada={"editar"} isformEditar={true} onSubmit={this.onSubmit} />
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="update ml-auto mr-auto">
                                                <button type="submit" className="btn btn-primary btn-round">Editar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

            </Fragment>
        )
    }

}